<template>
  <Layout>
    <main class="main-wrap">
      <div class="min-s-hight" style="width: 100%;">
        <section class="r-s-wrap">
          <div class="container devExtremeGridContainer">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-7">
                <a
                  class="color-black pageHeading"
                  style="font-size: 14px;color: #D13851;font-family: JosefinSans-SemiBold;cursor:pointer;"
                  @click="redirectToReportList"
                >
                  <u>
                    Back to Reports List
                  </u>
                </a>
              </div>
            </div>
            <div class="row mr-t20">
              <div class="col-12 col-sm-6 col-md-6 col-lg-7">
                <h2 class="color-black pageHeading"
                  >{{ reportName.name }}
                  <img src="/images/info.png" alt="" title="Reporting Analysis"
                /></h2>
                <label class="color-black mr-b30 pageHeading some-font">
                  {{ reportName.desc }}
                </label>
              </div>

              <div
                class="form-group col-12 col-sm-6 col-md-6 col-lg-5  mr-b30 "
              >
                <!-- {{ ProviderSelectedForService }} -->
                <h6 class="color-black pageHeading"> Select Report: </h6>
                <Multiselect
                  v-model="reportName"
                  tag-placeholder="Add this as new tag"
                  label="name"
                  track-by="id"
                  open-direction="below"
                  :options="reportList"
                  :multiple="false"
                  :taggable="false"
                  :preselect-first="true"
                  :searchable="false"
                  :allow-empty="false"
                  deselect-label="Can't remove this value"
                  :limit="3"
                >
                  <!-- <span slot="noResult">Oops! No elements found.</span> -->
                  <span slot="noResult">Report not found</span>
                </Multiselect>
              </div>
              <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-7 ">
                <div class="pull-right">
                  <input
                    v-model="dateFrom"
                    class="mr-r20"
                    placeholder="Start Date"
                    type="date"
                  />
                  <input v-model="dateTo" placeholder="End Date" type="date" />
                </div>
              </div> -->
            </div>

            <div class="services-tabs">
              <div class="cus-tabs">
                <!-- Nav tabs -->
                <!-- <ul class="nav nav-tabs mb-4"> -->
                <!-- <li class="nav-item cursor-pointer ml-0">
                    <a
                      class="nav-link ml-0"
                      :class="{ active: reportingSection === 1 }"
                      data-toggle="tab"
                      @click="changeStatus(1)"
                      >Building Analysis</a
                    >
                  </li>

                  <li class="nav-item cursor-pointer  ">
                    <a
                      class="nav-link ml-0"
                      :class="{ active: reportingSection === 2 }"
                      data-toggle="tab"
                      @click="changeStatus(2)"
                    >
                      Vendor Analysis</a
                    >
                  </li>

                  <li class="nav-item cursor-pointer ">
                    <a
                      class="nav-link ml-0"
                      :class="{ active: reportingSection === 3 }"
                      data-toggle="tab"
                      @click="changeStatus(3)"
                      >Category Analysis</a
                    >
                  </li>
                  <li class="nav-item cursor-pointer ">
                    <a
                      class="nav-link ml-0"
                      :class="{ active: reportingSection === 4 }"
                      data-toggle="tab"
                      @click="changeStatus(4)"
                      >Service Analysis</a
                    >
                  </li>
                  <li class="nav-item cursor-pointer ">
                    <a
                      class="nav-link ml-0"
                      :class="{ active: reportingSection === 5 }"
                      data-toggle="tab"
                      @click="changeStatus(5)"
                      >Inquiry Analysis</a
                    >
                  </li> -->
                <!-- <div class="mr-t30 mr-b20" style="width:100%;cursor:pointer"
                  ><i class="fa fa-download pull-right" aria-hidden="true"
                    >Download Report</i
                  ></div
                > -->

                <buildingAnalysis
                  v-if="reportingSection === 1"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></buildingAnalysis>
                <vendorAnalysis
                  v-if="reportingSection === 2"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></vendorAnalysis>
                <categoryAnalysis
                  v-if="reportingSection === 3"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></categoryAnalysis>
                <serviceAnalysis
                  v-if="reportingSection === 4"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></serviceAnalysis>
                <inquiryAnalysis
                  v-if="reportingSection === 5"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></inquiryAnalysis>
                <vendorRatingAnalysis
                  v-if="reportingSection === 6"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></vendorRatingAnalysis>
                <buildingRatingAnalysis
                  v-if="reportingSection === 7"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></buildingRatingAnalysis>
                <!-- <reconciliationReport
                  v-if="reportingSection === 8"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></reconciliationReport> -->
                <VendorPayoutAndOrderAnalysis
                  v-if="reportingSection === 9"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></VendorPayoutAndOrderAnalysis>
                <OrderAnalysisReport
                  v-if="reportingSection === 10"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></OrderAnalysisReport>
                <SandoEarning
                  v-if="reportingSection === 11"
                  :start-date="dateFrom"
                  :end-date="dateTo"
                ></SandoEarning>
                <!-- </ul> -->
              </div>
            </div>
          </div>
        </section>
        <loader v-if="loading"></loader>
        <popup
          v-if="showModal"
          :msg="postMessage"
          @response="showModal = false"
        ></popup>
      </div>
    </main>
  </Layout>
</template>

<script>
import moment from 'moment'
import popup from '@views/popup'
import Layout from '@layouts/main'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import { superAdminMethods } from '@state/helpers'
import loader from '@views/loader'
import appConfig from '@src/app.config'

import buildingAnalysis from '../adminAnalysisComponents/buildingAnalysis'
import categoryAnalysis from '../adminAnalysisComponents/categoryAnalysis'
import vendorAnalysis from '../adminAnalysisComponents/vendorAnalysis'
import serviceAnalysis from '../adminAnalysisComponents/serviceAnalysis'
import inquiryAnalysis from '../adminAnalysisComponents/inquiryAnalysis'
import vendorRatingAnalysis from '../adminAnalysisComponents/vendorRatingAnalysis'
import buildingRatingAnalysis from '../adminAnalysisComponents/buildingRatingAnalysis'

// import reconciliationReport from '../adminAnalysisComponents/reconciliationReport.vue'

import VendorPayoutAndOrderAnalysis from '../adminAnalysisComponents/vendorPayoutAndOrderAnalysis.vue'
import OrderAnalysisReport from '../adminAnalysisComponents/OrderAnalysisReport.vue'
import SandoEarning from '../adminAnalysisComponents/SandoEarning.vue'
import Multiselect from 'vue-multiselect'

export default {
  page: {
    title: 'Reporting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout: Layout,
    loader,
    popup,
    buildingAnalysis,
    categoryAnalysis,
    vendorAnalysis,
    serviceAnalysis,
    inquiryAnalysis,
    Multiselect,
    vendorRatingAnalysis,
    buildingRatingAnalysis,
    // reconciliationReport,
    VendorPayoutAndOrderAnalysis,
    OrderAnalysisReport,
    SandoEarning,
  },

  data() {
    return {
      showAllBuildings: false,
      reportName: {},
      reportingSection: 1,
      AllFacilityArray: [],
      loading: false,
      postMessage: null,
      showModal: false,
      deleteWarnPop: false,
      SearchByBuildingName: null,
      dateFrom: null,
      dateTo: null,
      reportList: [
        {
          id: 1,
          name: 'Building Analysis',
          desc:
            'This report will list down building names with the popular vendors and services they provide. It will also include inquiry and service counts.',
        },
        {
          id: 7,
          name: 'Building Rating Analysis',
          desc:
            'This report will list down average ratings for the different vendors for the services they provide and also will have a count of inquiries for particular services with other details.',
        },
        {
          id: 3,
          name: 'Category Analysis',
          desc:
            'This report will have a list of service categories and service count and total number of inquiries.',
        },
        {
          id: 5,
          name: 'Inquiry Analysis',
          desc:
            'This report shows the list of inquiries submitted by customers with names, service names and other details related to the inquiries.',
        },
        {
          id: 4,
          name: 'Service Analysis',
          desc:
            'This report has the list of all the services by all vendors, the category the service fall under and a count of how many times the inquiry has been placed for a particular service.',
        },
        {
          id: 2,
          name: 'Vendor Analysis',
          desc:
            'This report list downs all the vendors listed on the BuildingLink along with service counts and count of inquiry placed for the different services provided.',
        },
        {
          id: 6,
          name: 'Vendor Rating Analysis',
          desc:
            'This report shows the average rating of the vendors for the different categories of services provided along with the number of inquiries and service form count.',
        },
        // {
        //   id: 8,
        //   name: 'Reconciliation Report',
        //   desc:
        //     'This report shows the total number of transactions associated with a given vendor and services provided to make sure the account is balanced within a specific period of time.',
        // },
        /*commenting on 07-10-2022
        {
          id: 9,
          name: 'Vendor Payout & Order Analysis Report',
          desc:
            'This report list downs detailed information on the pay-outs and orders for a specific vendor for a specific range of time. It includes the total order completed, inprogress and refunded. Cost associated with these orders.',
        },
        {
          id: 10,
          name: 'Order Analysis Report',
          desc:
            'This report has all the orders listed down along with the resident that created the order, the vendor fulfilling the order. It also covers the margins on cost selected by the vendor and the total amount that a customer will pay.',
        },
        {
          id: 11,
          name: 'Sando Earning Report',
          desc:
            'This report shows gross profits for the BuildingLink, the amount received and the total amount due.',
        },*/
      ],
    }
  },
  watch: {
    reportName: {
      handler: function(val, oldVal) {
        console.log('startDate', val)
        if (val) this.reportingSection = val.id
      },
      deep: true,
    },
  },
  created() {
    var d = new Date()

    var mmNew = d.getUTCMonth() + 1
    var mmOld = d.getUTCMonth()
    var dd = d.getUTCDate()

    this.dateFrom = [
      d.getUTCFullYear(),
      (mmOld > 9 ? '' : '0') + mmOld,
      (dd > 9 ? '' : '0') + dd,
    ].join('-')

    this.dateTo = [
      d.getUTCFullYear(),
      (mmNew > 9 ? '' : '0') + mmNew,
      (dd > 9 ? '' : '0') + dd,
    ].join('-')

    let reportData = window.sessionStorage.getItem('ReportData')
    this.reportName = JSON.parse(reportData)
  },

  methods: {
    ...superAdminMethods,
    // Function to change active reportingSection

    redirectToReportList() {
      this.$router.push({ name: 'reporting' })
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
h6 {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
}

.h6style {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
  border-bottom: 1px solid black;
}

.has-search {
  width: 60%;
  margin-left: auto;
  position: relative;
  margin-bottom: 0px;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  /* height: 2.375rem; */
  height: calc(1.5em + 0.75rem + -4px);
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  top: 0px;
  left: 10px;
}

@media (max-width: 576px) {
  .s-red-btn img {
    margin: 0;
  }
  .pageHeading {
    font-size: 26px;
  }
  .has-search {
    width: 100%;
    /* border-top: 1px solid; */
    /* padding-top: 27px; */
    margin-bottom: 20px !important;
  }
  .form-check {
    margin-bottom: 20px !important;
  }
}
.form-check .form-check-input:checked ~ .form-check-label::before {
  background-color: black !important;
}
span.multiselect__option.multiselect__option--highlight.multiselect__option--selected {
  background: #d13851 !important;
}
span.multiselect__option.multiselect__option--highlight.multiselect__option--selected::after {
  background: #d13851 !important;
}
span.multiselect__option.multiselect__option--highlight {
  background: grey !important;
}
span.multiselect__option.multiselect__option--highlight::after {
  background: grey !important;
}
.multiselect__content-wrapper {
  max-height: 330px !important;
}

.some-font {
  font-size: 12px !important;
}
</style>
